export const HANDICAP_ALLOWANCE: Record<string, number> = {
  nassau: 1.0,
  match: 1.0,
  stroke: 0.95,
  skins: 1.0,
  fourball: 0.85,
  bestball: 0.85,
  scramble: 0.25,
  shamble: 0.85,
  wolf: 1.0,
  bingo: 1.0,
  vegas: 1.0,
};

export function courseHandicap(
  index: number | null | undefined,
  slope = 130,
  cr = 72,
  par = 72,
  holes = 18,
): number {
  if (index == null || Number.isNaN(index)) return 0;
  const raw = index * (slope / 113) + (cr - par);
  const ch = holes === 18 ? raw : raw / 2;
  return Math.round(ch);
}

export function playingHandicap(
  courseHcp: number,
  formatId: string,
  allowanceOverride?: number | null,
): number {
  const a = allowanceOverride ?? HANDICAP_ALLOWANCE[formatId] ?? 1.0;
  return Math.round(courseHcp * a);
}

export function strokesPerHole(courseHcp: number, strokeIndexes: number[]): number[] {
  const arr = strokeIndexes.map(() => 0);
  if (!courseHcp || courseHcp <= 0) return arr;
  let remaining = courseHcp;
  let pass = 1;
  while (remaining > 0) {
    const targetSi = ((pass - 1) % 18) + 1;
    const idx = strokeIndexes.findIndex((si) => si === targetSi);
    if (idx >= 0) arr[idx] += 1;
    remaining -= 1;
    pass += 1;
  }
  return arr;
}

export function netScoresFromGross(
  gross: (number | null)[],
  courseHcp: number,
  strokeIndexes: number[],
): (number | null)[] {
  const strokes = strokesPerHole(courseHcp, strokeIndexes);
  return gross.map((g, i) => {
    if (!Number.isFinite(g)) return null;
    return (g as number) - (strokes[i] || 0);
  });
}

/** Playing strokes relative to lowest handicap in the group (0 for the best player). */
export function groupRelativePlayingHandicap(
  players: Array<{ courseHcp: number }>,
  player: { courseHcp: number },
  formatId: string,
  allowanceOverride?: number | null,
): number {
  if (players.length < 2) return playingHandicap(player.courseHcp, formatId, allowanceOverride);
  const phs = players.map((p) => playingHandicap(p.courseHcp, formatId, allowanceOverride));
  const mine = playingHandicap(player.courseHcp, formatId, allowanceOverride);
  const min = Math.min(...phs);
  return Math.max(0, mine - min);
}
